<template>
  <div class="container-fluid">
    <ValidationObserver v-slot="{ handleSubmit }">
      <div class="letter-wrap">
        <div class="note-wrap">
          <div class="letter-title" v-if="MailCategoryName === '職缺意願'">
            職缺意願
          </div>
          <div class="letter-title" v-else-if="MailCategoryName === '面談邀約'">
            面談邀約
          </div>
          <div class="letter-title" v-else-if="MailCategoryName === '錄取通知'">
            錄取通知
          </div>
          <div class="letter-title" v-else-if="MailCategoryName === '感謝函'">
            感謝函
          </div>
          <div class="letter-title" v-else-if="MailCategoryName === '報到通知'">
            報到通知
          </div>
          <div class="letter-title" v-else>Offer 維護</div>

          <div class="note-title">可動態套入信件內容，請參考以下參數</div>
          <div class="note-table">
            <table v-if="mailParameter">
              <tr v-for="(parameter, index) in mailParameter" :key="index">
                <th>{{ parameter.MailParameterName }}</th>
                <td>
                  <span> {{</span>{{ parameter.MailParameterCode
                  }}<span>}} </span>
                </td>
              </tr>
            </table>
          </div>
        </div>
        <form>
          <div class="info-wrap">
            <div class="form-group">
              <ValidationProvider
                :name="i18n('Basic.Department')"
                rules="required"
                v-slot="{ errors }"
              >
                <label for="">
                  <span class="mark">*</span>
                  {{ i18n("Basic.Department") }}
                </label>
                <treeselect
                  :options="departmentOptions"
                  :searchable="true"
                  :show-count="true"
                  :default-expand-level="1"
                  placeholder="請選擇"
                  v-model="mail.DepartmentGuid"
                >
                  <label
                    slot="option-label"
                    slot-scope="{
                      node,
                      shouldShowCount,
                      count,
                      labelClassName,
                      countClassName,
                    }"
                    :class="labelClassName"
                    for=""
                  >
                    {{ node.label }}
                    <span v-if="shouldShowCount" :class="countClassName">
                      ({{ count }})
                    </span>
                  </label>
                </treeselect>
                <span v-if="errors[0]" class="text-danger">
                  {{ errors[0] }}
                </span>
              </ValidationProvider>
            </div>

            <div class="form-group">
              <ValidationProvider
                :name="i18n('Template.TemplateName')"
                class="w-100"
                rules="required"
                v-slot="{ errors }"
              >
                <label for="input-template-name">
                  <span class="mark">*</span>{{ i18n("Template.TemplateName") }}
                </label>
                <input
                  type="text"
                  id="input-template-name"
                  class="form-control w-100"
                  maxlength="50"
                  v-model.trim="mail.MailTemplateName"
                />
                <p
                  v-if="errors[0]"
                  class="text-danger"
                  style="margin-bottom: -10px"
                >
                  {{ errors[0] }}
                </p>
              </ValidationProvider>
            </div>

            <div class="form-group">
              <ValidationProvider
                :name="i18n('Template.MailSubject')"
                class="w-100"
                rules="required"
                v-slot="{ errors }"
              >
                <label for="input-template-subject">
                  <span class="mark">*</span>{{ i18n("Template.MailSubject") }}
                </label>
                <input
                  type="text"
                  id="input-template-subject"
                  class="form-control w-100"
                  maxlength="100"
                  v-model.trim="mail.MailTemplateSubject"
                />
                <p
                  v-if="errors[0]"
                  class="text-danger"
                  style="margin-bottom: -10px"
                >
                  {{ errors[0] }}
                </p>
              </ValidationProvider>
            </div>

            <div class="form-group">
              <ValidationProvider
                :name="i18n('Template.MailContent')"
                rules="required"
                v-slot="{ errors }"
              >
                <label for="">
                  <span class="mark">*</span>
                  {{ i18n("Template.MailContent") }}
                </label>
                <VueEditor
                  style="background: rgb(255, 255, 255)"
                  v-model="mail.MailTemplateBody"
                />
                <span v-if="errors[0]" class="text-danger">
                  {{ errors[0] }}
                </span>
              </ValidationProvider>
            </div>

            <div class="button-wrap center" style="margin-top: 25px">
              <button
                type="button"
                class="btn btn-secondary"
                style="margin-right: 5px"
                @click="$router.back()"
              >
                {{ i18n("Buttons.GoBack") }}
              </button>
              <button
                type="button"
                class="btn btn-success"
                @click="handleSubmit(updateMailTemplate)"
              >
                {{ i18n("Buttons.Save") }}
              </button>
            </div>
          </div>
        </form>
      </div>
    </ValidationObserver>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "EditLetter",

  data() {
    return {
      // 部門選項(treeSelect)
      departmentOptions: [],
      // 信件參數
      mailParameter: {},
      // 信件資訊
      mail: {},
    };
  },

  computed: {
    MailCategory() {
      return this.$store.state.LetterCategory;
    },
    MailCategoryName() {
      return this.$store.state.LetterCategoryName;
    },
    LetterEditGuid() {
      return this.$store.state.LetterEditGuid;
    },
  },

  methods: {
    // 編輯 信件範本
    updateMailTemplate() {
      this.updateLoading(true);
      this.$api.mailTemplate
        .putMailTemplate({
          ...this.mail,
          UpdateUser: this.$cookies.get("userName"),
        })
        .then((response) => {
          if (response.status === 200) {
            this.$notify({
              title: "成功",
              message: "範本編輯成功",
              type: "success",
              duration: 2000,
            });
            switch (this.MailCategoryName) {
              case "職缺意願":
                this.$router.push({ name: "範本維護,職缺意願" });
                break;
              case "面談邀約":
                this.$router.push({ name: "範本維護,面談邀約" });
                break;
              case "錄取通知":
                this.$router.push({ name: "範本維護,錄取通知" });
                break;
              case "報到通知":
                this.$router.push({ name: "範本維護,報到通知" });
                break;
              case "感謝函":
                this.$router.push({ name: "範本維護,感謝函" });
                break;
              case "Offer維護":
                this.$router.push({ name: "範本維護,offer維護" });
                break;
            }
          }
          this.updateLoading(false);
        });
    },

    async getData() {
      const content = await this.$api.mailTemplate.getMailTemplateDetail(
        this.LetterEditGuid
      );
      const parameter = await this.$api.mailTemplate.getMailParameter(
        this.MailCategory
      );
      const department = await this.$api.department.getDepartment();

      // 取得 信件範本內容
      this.mail = content.data;
      // 取得 信件範本參數
      this.mailParameter = parameter.data;
      // 取得 部門選項
      this.departmentOptions = department.data;

      this.updateLoading(false);
    },

    // loading
    ...mapActions(["updateLoading"]),

    // 多國語系
    i18n(keyStr) {
      return this.$t(keyStr);
    },
  },

  created() {
    this.getData();
  },
};
</script>
